import store from "../store";
import axios from "axios";
import router from "../router";

const aioTokenRefreshUrl =
  process.env.VUE_APP_API_URL_PREFIX + "/auth/v1/aiorefresh";

const options = {
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
};



// We dont need to intercept axios directly, we can do it at the routes.js level
axios.interceptors.response.use(
  (response) => {
    if (response.status === 401) {
      store.dispatch("logout");
      router.push("/login");
    }
    return response;
  },
  (error) => {
    if (error.response.status === 401) {
      store.dispatch("logout");
      // router.push("/login");
    }
    return error;
  },
);

export default function auth({ next, router }) {
  // console.log("results after regex ", urlParams.get("waltoken"));
  if (!store.getters.isAuthenticated) {
    const route = router.history._startLocation;
    if (route && route.startsWith("/verify")) {
      const walToken = route.startsWith("/verify?code=") ? route.replace("/verify?code=", "") : route.replace("/verify?walToken=", "");
      localStorage.setItem("vue-authenticate.access_token", walToken);
      axios.post(aioTokenRefreshUrl, options).then((response) => {
        const aioToken = response.data.response.aioToken;
        localStorage.setItem("testgold.aioToken", aioToken);
        router.push({ path: "/details/project-explorer/list-projects" });
      });
    } else return router.push({ name: "Login" });
  }

  return next();
}
